import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
// import StatusBar16ProMax from "../components/StatusBar16ProMax";
import NotificationPanel from "../components/NotificationPanel";
import ButtonContainer1 from "../components/ButtonContainer1";
import Footer from "../components/Footer";

const SettingWifi1 = () => {
  const navigate = useNavigate();

  const onHomeTextClick = useCallback(() => {
    navigate("/41-home");
  }, [navigate]);

  const onGroupSectionClick = useCallback(() => {
    navigate("/42-setting-wifi-done");
  }, [navigate]);

  return (
    <div
      className="relative bg-light-primary-key-background w-full overflow-hidden flex flex-col items-start justify-start gap-[57.5px] leading-[normal] tracking-[normal]"
    >
      {/* <StatusBar16ProMax
        statusBar16ProMaxBackgroundColor="unset"
        statusBar16ProMaxPosition="unset"
        statusBar16ProMaxTop="unset"
        statusBar16ProMaxLeft="unset"
      /> */}

      <section className="w-full z-[3]">
        <NotificationPanel
          notificationPanelPadding="0px 40px"
          onSettingWifiContainerClick={onHomeTextClick}
        />
      </section>

      <section
        className="flex flex-col items-start justify-end pt-[341px] px-0 pb-0 box-border relative max-w-full z-[4]"
        onClick={onGroupSectionClick}
      >
        <ButtonContainer1 />
        <Footer />
      </section>
    </div>
  );
};

export default SettingWifi1;
